import React from 'react';
import './CustomDialog.css';

class CustomDialog extends React.Component {
  render() {
    let { title, text, cancelText, confirmText, onClose } = this.props;
    return (
      <div className="confirmation-dialog">
        <h1>{title}</h1>
        <p>{text}</p>
        {confirmText && <button
          onClick={() => {
            onClose();
            this.props.handleConfirming();
          }}
        >
          {confirmText}
        </button>}
        <button onClick={onClose}>{cancelText}</button>
      </div>
    );
  }
}

export default CustomDialog;
